export const queries = [
    {
        Q: "오늘 하루가 끝나고 당신은 침대에 누웠습니다. 오늘 하루는 어땠나요?",
        A: [
            [
                "오늘도 피곤한 하루였어. 아.... 내일 또 출근이라니!", {
                    "nature": 10,
                    "density": -10
                }
            ],
            [
                "친구를 잔뜩 만났지! 꽤나 즐거웠어.", {
                    "nature": 0,
                    "density": 10
                }
            ],
            [
                "오늘은 집에 있었지. 내일도 그럴거야!", {
                    "nature": 0,
                    "density": -10
                }
            ],
            [
                "산에도 가고, 바다에도 가고! 내일은 또 캠핑을 갈거야!", {
                    "nature": 10,
                    "density": 10
                }
            ]
        ]
    }, {
        Q: "내일은 어떤 날씨였으면 좋겠나요?",
        A: [
            [
                "언제나 맑음!", {
                    "nature": 10,
                    "density": 10
                }
            ],
            [
                "비가 와줬으면 좋겠네", {
                    "nature": 10,
                    "density": -10
                }
            ],
            [
                "글쎄, 어찌되어도 상관없어", {
                    "nature": -10,
                    "density": -10
                }
            ],
            [
                "기상예보를 보는 게 어떠니?", {
                    "nature": -10,
                    "density": -10
                }
            ]
        ]
    }, {
        Q: "내일은 즐거운 운동회! 너는 어때? 좋아하니?",
        A: [
            [
                "당연! 우리가 일등을 할거야!", {
                    "nature": 10,
                    "density": 10
                }
            ],
            [
                "마침 몸이 찌뿌둥했어. 좀 달려볼까?", {
                    "nature": 10,
                    "density": 0
                }
            ],
            [
                "으엑, 생각하기도 싫은데?", {
                    "nature": 10,
                    "density": 0
                }
            ],
            [
                "북적북적, 떠뜰썩... 어디 혼자 숨어있어야지", {
                    "nature": 0,
                    "density": -10
                }
            ]
        ]
    }, {
        Q: "쾅! 천둥 번개가 친다!",
        A: [
            [
                "뭐야! 어디야! 보고싶어!", {
                    "nature": 10,
                    "density": 10
                }
            ],
            [
                "으악! 도망쳐! 귀를 막아!", {
                    "nature": -10,
                    "density": 0
                }
            ],
            [
                "뭐야, 번개가 치는 일 정도는 흔하잖아. 조용히 있게 내버려둬.", {
                    "nature": -10,
                    "density": -10
                }
            ],
            [
                "아~ 내일 놀러가려 했는데. 내일은 맑았으면 좋겠다~", {
                    "nature": -10,
                    "density": 10
                }
            ]
        ]
    }, {
        Q: "잠자기 전 유*브를 켰습니다. 알고리즘이 당신에게 추천한 동영상은 무엇인가요?",
        A: [
            [
                "Vlog", {
                    "nature": 0,
                    "density": 10
                }
            ],
            [
                "고양이, 강아지 영상", {
                    "nature": 10,
                    "density": 0
                }
            ],
            [
                "게임 영상", {
                    "nature": 0,
                    "density": -10
                }
            ],
            [
                "ASMR", {
                    "nature": 10,
                    "density": -10
                }
            ]
        ]
    }, {
        Q: "오랜만에 서점에 왔습니다. 어떤 책이 제일 먼저 눈에 띄나요?",
        A: [
            [
                "과학 도서", {
                    "nature": 10,
                    "density": -10
                }
            ],
            [
                "패션 잡지", {
                    "nature": 0,
                    "density": 10
                }
            ],
            [
                "사실 서점은 가지 않습니다. e-book이 있잖아요?", {
                    "nature": -10,
                    "density": -10
                }
            ],
            [
                "책 보다는 작은 화분", {
                    "nature": 10,
                    "density": 0
                }
            ]
        ]
    }, {
        Q: "동물을 좋아하시나요? 어떤 반려 동물과 함께 하고 싶나요?",
        A: [
            [
                "강아지", {
                    "nature": 10,
                    "density": 10
                }
            ],
            [
                "고양이", {
                    "nature": 10,
                    "density": 0
                }
            ],
            [
                "사실, 동물을 키우고 싶지 않아", {
                    "nature": -10,
                    "density": -10
                }
            ],
            [
                "말", {
                    "nature": 10,
                    "density": 10
                }
            ]
        ]
    }, {
        Q: "가장 좋아하는 과목은 무엇이었나요?",
        A: [
            [
                "음악", {
                    "nature": 0,
                    "density": 10
                }
            ],
            [
                "체육", {
                    "nature": 10,
                    "density": 10
                }
            ],
            [
                "미술", {
                    "nature": 10,
                    "density": 0
                }
            ],
            [
                "보기가 다 왜이래! 나는 다 싫어", {
                    "nature": -10,
                    "density": -10
                }
            ]
        ]
    }, {
        Q: "가장 좋아하는 반찬!",
        A: [
            [
                "소세지", {
                    "nature": -10,
                    "density": 0
                }
            ],
            [
                "김치", {
                    "nature": 10,
                    "density": 0
                }
            ],
            [
                "참치캔", {
                    "nature": 10,
                    "density": 0
                }
            ],
            [
                "사실, 난 밥보다 술이 좋아", {
                    "nature": 0,
                    "density": 10
                }
            ]
        ]
    }, {
        Q: "좋아하는 영화 장르는 어떻게 되니?",
        A: [
            [
                "SF", {
                    "nature": -10,
                    "density": 0
                }
            ],
            [
                "힐링", {
                    "nature": 10,
                    "density": -10
                }
            ],
            [
                "액션", {
                    "nature": 0,
                    "density": 10
                }
            ],
            [
                "로맨스", {
                    "nature": 0,
                    "density": 10
                }
            ]
        ]
    }
    
];